// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  clientId: 'local',
  apiUrl: '',
  companyRefUrl: '',
  companySearchUrl: '',
  jadeUrl: '',
  customerVettingUrl: 'http://localhost:3000',
  customerVettingFrontUrl: 'http://localhost:4200',
  dynatraceUrl: '/fake.js',
  dynatraceRuxitUrl: '/fake.js',
  groupTicketingFrontUrl: '',
  esgScoringUrl: '',
  publicKey: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAuuQRB9u5vSc+FHDHrrRq
vu7YO7wUqQYXCBHzxnbhKHQiK3gr0zfJHAjx5nb94ymIAdrxbKTlfUYj7z9TlpQg
lbTD+Z/amEayXE6Us7plsaGemDBmW+4px7tqS+fB9B/S4y3DQmeRIuxUNbo5uUnF
IX9XWuwvmXzN6F2AlXzPnwA0SCjBP/LaHa97cJuZll3BYNNcnyYp2iQLTzUluMnW
eAecj9FJGgKhzCwXb6ecRO1lyCerGYi4M1jb/H+QYEwvPiILrMYJu6wr9qFo3Z46
My0OfjBNSKr3YHTfo34tV9L9jQmJC9HL/Qs8MoO1jZFtJpsYVLXIw1LpI/aGB8Lh
9iYgpSkY+WEcdNJa1Y8p78GEtqxnwqOpklNyfSI7JcqSj831+ghRQgpmA4w1stad
2heWTwvS2agEfIBXStWhbPvGowySH80XeYXY2bolk/PbUDlB5/pzIMwgvN4bCOig
/ZkhKPXuMz7X8tJPIJkcy0LnN/91E9SDO2bWWFJjqGE0DCyWVRIufQAT1pV9NKYu
zWqA+QTQDxHjjhILh+mGaECH/wsVXCPqVEycrNmyjdLKpn9n3F2s/vlEwq8P+5Ru
Uuy8Ssdhrm6ZGw0nU7KCWNOD2JzH2brdQve8RBO5ZXHcd/7Q1x5Hb8asfoYTtjnx
HU7kHLGWkWK7xqrH95Bfa10CAwEAAQ==
-----END PUBLIC KEY-----`,
  pollingDelayFactor: 1,
  featureToggles: {
    translations: true,
    massUpload: true,
    lineOfBusiness: true,
    gradeAutoRefresh: true,
    supportRequest: {
      SFAC: true,
      SIAC: true,
      EHBG: true,
      EHSK: true,
      HHUN: true,
      CSOB: true,
      EHRO: true,
      HERM: true,
      TI: true,
      EHNO: true,
      EHFI: true,
      EHDK: true,
      EHSE: true,
      HSWI: true,
      CBAC: true,
      CBNL: true,
      EHIE: true,
      HPOL: true,
      EHBR: true,
      EHCA: true,
      ACI: true,
      EBSG: true,
      EHJP: true,
      EHAU: true,
      EHNZ: true,
      EBHK: true,
      EHTW: true,
      EHGR: true,
      EHMA: true,
      EHZA: true,
      EBCN: true,
      CSEC: true,
      EHTR: true,
      EHAE: true,
    },
    esgScoringTool: {
      SFAC: true,
      SIAC: true,
      EHBG: true,
      EHSK: true,
      HHUN: true,
      CSOB: true,
      EHRO: true,
      HERM: true,
      TI: true,
      EHNO: true,
      EHFI: true,
      EHDK: true,
      EHSE: true,
      HSWI: true,
      CBAC: true,
      CBNL: true,
      EHIE: true,
      HPOL: true,
      EHBR: true,
      EHCA: true,
      ACI: true,
      EBSG: true,
      EHJP: true,
      EHAU: true,
      EHNZ: true,
      EBHK: true,
      EHTW: true,
      EHGR: true,
      EHMA: true,
      EHZA: true,
      EBCN: true,
      CSEC: true,
      EHTR: true,
      EHAE: true,
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
